var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import gql from 'graphql-tag';
import { isString } from 'lodash';
import * as React from 'react';
import { useQuery } from 'react-apollo-hooks';
import { ODWebUtils } from '../utils';
export function useODQuery2(gqlOrString, options) {
    var _this = this;
    if (options === void 0) { options = {}; }
    var defaultOptions = {
        skip: false,
        simulateDelay: 0,
        pickFirstKey: false,
        refreshInterval: 0,
        wrapVariablesWithData: true,
        showErrorToast: false,
    };
    var op = __assign(__assign({}, defaultOptions), options);
    var simulateDelay = op.simulateDelay, pickFirstKey = op.pickFirstKey, variables = op.variables, _a = op.refreshInterval, refreshInterval = _a === void 0 ? 0 : _a, wrapVariablesWithData = op.wrapVariablesWithData;
    // @ts-ignore => peer deps 와 관련된 오류로 파악된다.
    var _b = useQuery(isString(gqlOrString) ? gql(gqlOrString) : gqlOrString, {
        skip: op.skip,
        errorPolicy: 'none',
        variables: wrapVariablesWithData ? { data: variables } : variables,
        client: options.client,
    }), data = _b.data, error = _b.error, loading = _b.loading, refetch = _b.refetch;
    var _c = React.useState(data), processedData = _c[0], setProcessedData = _c[1];
    React.useEffect(function () {
        if (pickFirstKey && data) {
            setProcessedData(data[Object.keys(data)[0]]);
        }
        else {
            setProcessedData(data);
        }
    }, [pickFirstKey, data]);
    var api = React.useCallback(function (input) { return __awaiter(_this, void 0, void 0, function () {
        var res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, new Promise(function (resolve) { return setTimeout(resolve, simulateDelay); })];
                case 1:
                    _a.sent();
                    return [4 /*yield*/, refetch(wrapVariablesWithData ? { data: input } : input)];
                case 2:
                    res = _a.sent();
                    if (pickFirstKey) {
                        return [2 /*return*/, ODWebUtils.extractGQLResponse(res)];
                    }
                    return [2 /*return*/, res.data];
            }
        });
    }); }, [refetch, simulateDelay, pickFirstKey, wrapVariablesWithData]);
    React.useEffect(function () {
        if (refreshInterval > 0) {
            var handler_1 = setInterval(function () { return refetch({ data: variables }); }, refreshInterval);
            return function () { return clearInterval(handler_1); };
        }
    }, [refreshInterval, variables, refetch]);
    React.useEffect(function () {
        if (error) {
            ODWebUtils.showError(error);
        }
    }, [error]);
    return { api: api, data: processedData, error: error, loading: loading, refetch: refetch };
}
//# sourceMappingURL=useODQuery2.js.map